/**
 * 逻辑流编辑器 - 代码预览面板
 */

import React from 'react';
import {Alert, Button, Tag, Typography} from 'antd';
import {CopyOutlined, ReloadOutlined} from '@ant-design/icons';
import type {ValidationResult} from '../../../store/logicFlowStore';

const {Text, Paragraph} = Typography;

interface Props {
    strategyCode: string;
    validationResult: ValidationResult | null;
    onRefresh: () => void;
}

const CodePreviewPanel: React.FC<Props> = ({strategyCode, validationResult, onRefresh}) => {
    const handleCopy = () => {
        navigator.clipboard.writeText(strategyCode);
    };

    return (
        <div style={containerStyle}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <Text strong style={{color: 'var(--pt-text-primary)', fontSize: '14px'}}>代码预览</Text>
                <div style={{display: 'flex', gap: '4px'}}>
                    <Button size="small" icon={<ReloadOutlined/>} onClick={onRefresh} title="刷新"/>
                    <Button size="small" icon={<CopyOutlined/>} onClick={handleCopy} title="复制"/>
                </div>
            </div>

            {validationResult && (
                <div>
                    {validationResult.valid ? (
                        <Tag color="green">校验通过</Tag>
                    ) : (
                        <Tag color="red">校验失败</Tag>
                    )}
                    {validationResult.errors.map((err, i) => (
                        <Alert key={`e${i}`} type="error" message={err} style={{marginTop: '4px'}} showIcon/>
                    ))}
                    {validationResult.warnings.map((warn, i) => (
                        <Alert key={`w${i}`} type="warning" message={warn} style={{marginTop: '4px'}} showIcon/>
                    ))}
                </div>
            )}

            <pre style={codeStyle}>
                <code>{strategyCode || '点击"刷新"生成策略代码'}</code>
            </pre>
        </div>
    );
};

const containerStyle: React.CSSProperties = {
    padding: '14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    height: '100%',
    overflowY: 'auto',
};

const codeStyle: React.CSSProperties = {
    flex: 1,
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid rgba(255,255,255,0.08)',
    background: 'rgba(0,0,0,0.3)',
    color: 'var(--pt-text-primary)',
    fontSize: '12px',
    lineHeight: 1.6,
    fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
    overflow: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
    margin: 0,
};

export default CodePreviewPanel;
